<template>
  <header
    class="c-header c-header-mobile w-100 pb-0"
    :class="{ 'c-header-mobile--visible' : switcher}">
    <div class="container">
      <nav class="c-nav w-100 mb-5">
        <div class="c-nav__left w-100 d-flex justify-content-center align-items-center my-5">
          <figure class="c-brand c-brand--normal d-flex justify-content-center align-items-center">
            <router-link class="c-brand__link" to="/">
              <img class="c-brand__image" src="@/assets/images/logo.png" alt="Panda WP - Logo" />
            </router-link>
          </figure>
        </div>
        <div class="c-nav__right">
          <ul class="c-menu dropdown vertical menu accordion-menu d-flex ul-reset">
            <li
              v-for="item of general.data.primary_menu"
              :key="item.id"
              :class="[
                'flex-container flex-dir-column align-middle',
                item.class,
                {'activate' : item.classes.includes('current-menu-item')}
              ]">
              <router-link
                :to="item.url"
                class="position-relative flex-container align-middle padding-1"
              >
                {{ item.name }}
              </router-link>
              <ul v-if="item.children.length" class="ul-reset menu vertical nested margin-top-1" >
                <li
                  v-for="child of item.children"
                  :key="child.id">
                  <a class="white" :href="child.url">{{ child.name }}</a>
                </li>
              </ul>
            </li>
          </ul>
          <div class="d-flex gap-4 flex-column align-items-center">
            <router-link to="/" class="c-link">
              Inicio
            </router-link>
            <router-link to="/nosotros" class="c-link">
              Nosotros
            </router-link>
            <router-link to="/servicios" class="c-link">
              Servicios
            </router-link>
            <router-link to="/noticias" class="c-link">
              Noticias
            </router-link>
            <router-link to="/contacto" class="c-link">
              Contacto
            </router-link>
            <router-link to="/responsabilidad-social" class="c-link">
              Responsabilidad Social
            </router-link>
          </div>
        </div>
      </nav>
      <div class="c-wr mb-4"></div>
      <div v-if="general.data.information"
        class="d-flex flex-column flex-md-row justify-content-md-between py-3 align-items-center"
      >
        <div class="d-md-flex align-items-center mb-3 mb-md-0">
          <p class="sec-color fs-14 w-medium mb-0 me-4">
            <span class="pri-alt fs-21 me-1">
              <Icon icon="ph:phone-bold"/>
            </span>
            {{general.data.information.telephone}} / {{general.data.information.phone}}
          </p>
          <a href="">
            <span class="pri-alt fs-21 me-1">
              <Icon icon="octicon:mail-16"/>
            </span>
            {{general.data.information.email}}
          </a>
        </div>
        <div class="c-social">
          <a
            target="_blank"
            v-if="general.data.information.facebook"
            :href="general.data.information.facebook"
            class="c-social__link"
          >
            <span>
              <Icon icon="ri:facebook-fill"/>
            </span>
          </a>
          <a
            target="_blank"
            v-if="general.data.information.youtube"
            :href="general.data.information.youtube"
            class="c-social__link"
          >
            <Icon icon="iconoir:youtube"/>
          </a>
          <a
            target="_blank"
            v-if="general.data.information.instagram"
            :href="general.data.information.instagram"
            class="c-social__link"
          >
            <Icon icon="fe:instagram"/>
          </a>
          <a
            target="_blank"
            v-if="general.data.information.linkedin"
            :href="general.data.information.linkedin"
            class="c-social__link"
          >
            <Icon icon="ri:linkedin-fill"/>
          </a>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: ['switcher'],
  computed: {
    ...mapState(['general']),
  },
  methods: {
    isAtiveMenuItem(item) {
      return item.slug.toLowerCase() === this.$route.name.toLowerCase();
    },
  },
};
</script>
